<template>
  <layout-component>
    <template v-if="bookingClosed">
      <div class="container">
        <div class="row pt-4 pt-md-4 pt-lg-5 pb-4">
          <div class="col-md-8 offset-md-2">
            <h3 class="left-bullet" v-html="$t('w.cart.bookings-closed')"></h3>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <template v-if="$store.cart.content && $store.cart.content.length && $store.rooms.content">
        <div class="banner banner-blog">
          <div class="container">
            <div class="row">
              <div class="col-md-6 offset-md-3">
                <h1 class="left-bullet" v-html="$t('w.cart.title-banner')"></h1>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="container cart">
        <template v-if="$store.cart.content && $store.cart.content.length && $store.rooms.content">
          <div class="row">
            <div class="col-md-10">
              <b-list-group class="cart-list">
                <div v-for="(cartitem,index) in $store.cart.content" :key="index">

                  <!--
                    Rooms
                  -->
                  <b-list-group-item class="cart-item d-md-flex align-items-md-center justify-content-md-between" v-if="cartitem.room_id && $store.rooms.content[cartitem.room_id-1]">
                    <div class="img-wrapper">
                      <div class="room-image" :style="'background-image:url('+$store.rooms.content[cartitem.room_id-1].images[0]+')'"></div>
                    </div>
                    <div class="text-wrapper d-md-flex align-items-md-start justify-content-md-between">
                      <div class="left-infos">
                        <h5>{{'w.cart.title-room'|t}}</h5>
                        <div class="room-name">{{'w.cart.title-room'|t}} n°{{cartitem.room_id}}</div>
                        <div class="booking-date">{{cartitem.date|formatDate}}</div>
                        <div class="booking-hours">{{'w.cart.from'|t}} {{cartitem.from}}:00 {{'w.cart.to'|t}} {{cartitem.to}}:00</div>
                        <div class="admin-comment" v-if="$auth.check(2)">Admin comment: {{cartitem.comment}}</div>
                      </div>
                      <div class="right-infos">
                        <template v-if="cartitem.price_reduced != null">
                        <div class="booking-price"><del>{{cartitem.price}}€</del> {{cartitem.price_reduced}}€</div>
                        </template>
                        <template v-else>
                        <div class="booking-price">{{cartitem.price}}€</div>
                        </template>
                        <div @click="deleteCartItem(cartitem.id)" class="trash-wrapper"><simple-svg :filepath="'/storage/img/icon/icon-trash.svg'" /></div>
                      </div>
                    </div>
                  </b-list-group-item>

                  <!--
                    Events
                  -->
                  <b-list-group-item class="cart-item d-md-flex align-items-md-center justify-content-md-between" v-else>
                    <div class="img-wrapper">
                      <div class="room-image" :style="`background-image:url('storage/${cartitem.event.cover}')`"></div>
                    </div>
                    <div class="text-wrapper d-md-flex align-items-md-start justify-content-md-between">
                      <div class="left-infos">
                        <h5>{{ $i18n.locale == 'fr' ? cartitem.event.category.name : cartitem.event.category.name_en }}</h5>
                        <router-link class="room-name" :to="/events/+cartitem.event.slug" active-class="active">{{cartitem.event.name}} (x{{ cartitem.tickets }})</router-link>

                        <div class="booking-date">{{cartitem.date|formatDate}}</div>
                        <div class="booking-hours">{{'w.cart.from'|t}} {{cartitem.event.from | formatTimeEvent}} {{'w.cart.to'|t}} {{cartitem.event.to | formatTimeEvent}}</div>
                      </div>
                      <div class="right-infos" v-if="cartitem.price">
                        <template v-if="cartitem.price_reduced != null">
                        <div class="booking-price"><del>{{cartitem.price}}€</del> {{cartitem.price_reduced}}€</div>
                        </template>
                        <template v-else>
                        <div class="booking-price">{{cartitem.price}}€</div>
                        </template>
                        <div @click="deleteCartItem(cartitem.id)" class="trash-wrapper"><simple-svg :filepath="'/storage/img/icon/icon-trash.svg'" /></div>
                      </div>
                      <div class="right-infos" v-else>
                        <div class="booking-price">{{'w.cart.event-free'|t}}</div>
                        <div @click="deleteCartItem(cartitem.id)" class="trash-wrapper"><simple-svg :filepath="'/storage/img/icon/icon-trash.svg'" /></div>
                      </div>
                    </div>
                  </b-list-group-item>

                </div>
                <!-- Modal  -->
                <b-modal id="applyCoupon" ref="couponModale" size="lg" scrollable centered hide-footer hide-header content-class="edit-coupon">
                  <button type="button" :aria-label="$t('w.common.close')" class="close" @click="hideModal()">
                    <b-img src="/storage/img/icon/icon-cross-close-modal.svg" class="cross-close-modal" width="16" height="16" />
                  </button>

                  <div class="content">
                    <h3 class="left-bullet">{{'w.cart.coupon-modal-title'|t}}</h3>
                    <p>{{'w.cart.coupon-modal-text'|t}}</p>

                    <ul>
                      <li v-for="(cartitem, index) in filteredCartItems" :key="index">
                        <input type="radio" :id="'product-' + index" :value="cartitem.id" v-model="selectedProduct" />
                        
                        <label :for="'product-' + index">
                          <div v-if="cartitem.room_id">
                            <div class="room-name">{{'w.cart.title-room'|t}} n°{{cartitem.room_id}}</div>
                            <div class="booking-date">{{cartitem.date|formatDate}}</div>
                            <div class="booking-hours">{{'w.cart.from'|t}} {{cartitem.from}}:00 {{'w.cart.to'|t}} {{cartitem.to}}:00</div>
                          </div>

                          <div v-else>
                            <div>{{ $i18n.locale == 'fr' ? cartitem.event.category.name : cartitem.event.category.name_en }}</div>
                            <div class="room-name">{{cartitem.event.name}} (x{{ cartitem.tickets }})</div>
                            <div class="booking-date">{{cartitem.date|formatDate}}</div>
                          </div>
                        </label>

                        <div class="booking-price">{{cartitem.price}}€</div>
                      </li>
                    </ul>

                    <button type="button" class="btn btn-primary mt-3" :disabled="!selectedProduct" @click="applyCoupon(), hideModal()"><span>{{'w.cart.coupon-modal-submit'|t}}</span></button>
                  </div>
                </b-modal>
              </b-list-group>
            </div>
          </div>

          <div v-if="$auth.check(2)" class="row d-flex justify-content-center pt-1 pb-4 pt-md-3">
              <div class="col-md-6 go-checkout-wrapper">
                <div class="price-wrapper text-md-center">
                  <p class="cart-total"><span class="cart-total-price">{{ $store.cart.total.toLocaleString() }}€</span></p>
                  <p class="cart-vat">{{'w.cart.included-vat'|t}} {{($store.cart.total-$store.cart.total/1.17).toFixed(2)}}€</p>
                </div>
                <b-button @click.once="confirmBooking()" class="submit">
                  <span>{{'w.cart.confirm-admin-booking'|t}}</span>
                </b-button>
                <router-link class="btn mt-2 mt-md-3 mb-2 mb-md-0 w-100" to="/book" active-class="active"><span>{{'w.cart.continue-btn'|t}}</span></router-link>
            </div>
          </div>
          <div v-else class="row d-flex justify-content-center pt-1 pb-4 pt-md-3">
              <div class="col-md-8 col-lg-6 go-checkout-wrapper">
                <div class="price-wrapper text-md-center">
                  <p class="cart-total"><span class="cart-total-price">{{$store.cart.total.toLocaleString()}}€</span></p>
                  <template v-if="$store.user.coupon_id">
                    <p class="cart-coupon">{{'w.cart.active-coupon-code'|t}} {{$store.user.coupon.code}} (-{{$store.user.coupon.discount}}{{ ('w.cart.' + $store.user.coupon.mode) | t }})</p>
                  </template>
                  <p class="cart-vat">{{'w.cart.included-vat'|t}} {{($store.cart.total-$store.cart.total/1.17).toFixed(2)}}€</p>
                  <p v-if="$store.user.balance > 0">
                    {{'w.cart.user-balance'|t}}: {{$store.user.balance}}€
                  </p>
                </div>
                <form class="coupon-wrapper row" @submit.prevent="applyCoupon">
                  <div class="form-group col" :class="{ 'has-error': has_error }">
                      <label for="coupon-code">{{'w.cart.label-coupon-code'|t}}</label>
                      <div class="input-wrapper">
                        <b-form-input type="text" id="coupon-code" v-model="couponcode"></b-form-input>
                        <span class="focus-border"></span>
                      </div>
                      <small class="form-text text-danger" v-if="has_error">{{ couponError }}</small>
                  </div>
                  <div class="form-group col">
                      <b-button @click="applyCoupon" class="apply" v-bind:disabled="couponcode === ''"><span>{{'w.cart.apply-coupon-code'|t}}</span></b-button>
                  </div>
                </form>
                <div class="checkbox-wrapper pt-2 pb-2 pt-md-3">
                    <b-form-checkbox id="agreerules" name="agreerules" value="agreerules" v-model="agreerules" unchecked-value="" class="cart-agreerules">
                      <span v-html="$t('w.cart.checkbox-terms-of-use')"></span>
                      <div v-html="$t('w.cart.checkbox-terms-of-use-link')"></div>
                      <span class="required">*</span>
                    </b-form-checkbox>

                    <b-form-checkbox id="agreeterms" name="agreeterms" value="agreeterms" v-model="agreeterms" unchecked-value="">
                      {{'w.cart.checkbox-cookie-policy'|t}} <span class="required">*</span>
                    </b-form-checkbox>
                </div>
                <b-button @click.once="openStripeCheckout()" class="submit" v-bind:disabled="!agreerules || !agreeterms">
                  <template v-if="isHidden"><span class="text">{{'w.cart.cart-btn-loading'|t}}</span> <loader /></template>
                  <template v-else><span>{{'w.cart.cart-btn'|t}}</span></template>
                </b-button>
                <router-link class="btn mt-2 mt-md-3 mb-2 mb-md-0 w-100" to="/book" active-class="active"><span>{{'w.cart.continue-btn'|t}}</span></router-link>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="row pt-4 pt-md-4 pt-lg-5 pb-4">
            <div class="col-md-8 offset-md-2">
              <h3 class="left-bullet" v-html="$t('w.cart.empty-title')"></h3>
              <p>{{'w.cart.empty-text'|t}}</p>
              <router-link class="btn mt-2 mt-md-3 mb-2 mb-md-0" to="/book" active-class="active"><span>{{'w.cart.empty-btn'|t}}</span></router-link>
            </div>
          </div>
        </template>
      </div>
    </template>
	</layout-component>
</template>

<script>
    export default {
        data() {
          return {
            bookingClosed: false, //Set to true to disable bookings (COVID-19)
            isHidden: false,
            agreerules: false,
            agreeterms: false,
            has_error: false,
            couponcode: '',
            selectedProduct: '',
            selectedProductModal: false,
            coupon: null,
          }
        },
        computed: {
          // Translate the coupon-error wording key; fall back to the raw value (server message).
          couponError() {
            if (!this.has_error) return '';
            const key = 'w.cart.' + this.has_error;
            const translated = this.$t(key);
            return translated === key ? this.has_error : translated;
          },
        },
        methods: {
          deleteCartItem(cartid) {
            Vue.axios.delete('/cart/'+cartid).then(({data}) => {
              this.$store.setCart(data)
              this.$store.reloadUser()
            })
            // En cas d'échec : pas de mutation (l'item reste dans le panier = état correct),
            // on évite juste la promesse rejetée non gérée.
            .catch(() => {})
          },
          hideModal() {
            this.$refs.couponModale.hide()
          },
          applyCoupon() {
            Vue.axios.post('/apply-coupon', {
              'coupon': this.couponcode,
              'product': this.selectedProduct
            }).then(({data}) => {
              if(data.hasOwnProperty('error')) {
                if(data.hasOwnProperty('coupon')) {
                  this.coupon = data.coupon;
                  this.selectedProductModal = true;
                  this.$bvModal.show('applyCoupon');
                } else {
                  this.has_error = data.error;
                }
              } else {
                this.has_error = false
                this.couponcode = '';
                this.selectedProduct = '';
                this.$store.reloadUser()
                this.$store.loadCart()
              }
            })
            .catch((error) => {
              if (error.response && error.response.data && error.response.data.errors) {
                this.has_error = Object.values(error.response.data.errors).flat().join(', ');
              } else {
                this.has_error = 'error-coupon-generic';
              }
            });
          },
          openStripeCheckout() {
            this.isHidden = true
            Vue.axios.post('/order', {}).then(({data}) => {
              if (typeof data.total != "undefined" && data.total < 0.50) {
                this.$store.loadCart()
                // refresh balance after a gift-card-covered order (no Stripe round-trip)
                this.$store.reloadUser()
                this.$router.push('/booking-success')
              } else {
                stripe.redirectToCheckout({
                  sessionId: data.id
                }).then(function (result) {
                });
              }
            })
          },
          confirmBooking() {
            Vue.axios.post('/order', {}).then(({data}) => {
              this.$store.loadCart()
              this.$router.push('/admin')
            })
          }
        },
        computed: {
          filteredCartItems() {
            if (!this.coupon || !this.coupon.product_type) {
              return this.$store.cart.content;
            }
            return this.$store.cart.content.filter(cartitem => {
              if (this.coupon.product_type === 'event') {
                return cartitem.event;
              } else if (this.coupon.product_type === 'room') {
                return cartitem.room_id;
              }
              return true;
            });
          }
        },
        mounted() {
          this.$store.loadCart()
        }
    }
</script>
